import { createForm } from 'shared-ui/lib/customs/form/FormGenerator';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import * as Yup from 'yup';
import { UserLevel } from '../../hooks/use-can';
import { userInputs } from '../../inputs/user.inputs';

const form: FormInput[] = [
  userInputs.name,
  userInputs.email,
  userInputs.inviteLevel,
  userInputs.isEmployee,
];

const created = createForm(form);

export const inviteUserForm = {
  Element: created.Element,
  meta: {
    initValues: {
      ...created.meta.initValues,
      level: UserLevel.BASIC,
    },
    validateSchema: created.meta.validateSchema.concat(
      Yup.object().shape({
        level: Yup.string().required(),
      })
    ),
  },
};

export type InviteUserFormBody = {
  email: string;
  name: string;
  level: string;
  isEmployee: boolean;
};
